import { WorldpayResult } from '../../models/worldpay/worldpay-result.interface';
import { WorldpayStatus } from '../../models/worldpay/worldpay-status.enum';

export const mockWorldpayResult: WorldpayResult = {
  order: {
    orderKey: 'UKSWWAVU727012300001',
    status: WorldpayStatus.Success,
  },
};
